module.exports = __webpack_public_path__ + "assets/ziyuan_6.db56bb9f.svg";